import { ShuffleIcon } from '@radix-ui/react-icons';
import { Box } from '@radix-ui/themes';
import { HittersHelper } from 'classes/helpers/hitters.helper';
import { CommonCallout } from 'components/common/callouts';
import { ErrorBoundary } from 'components/common/error-boundary';
import { HitterLibraryDuplicateDialog } from 'components/sections/hitter-library/duplicate-dialog';
import { HittersContext } from 'contexts/hitters.context';
import { t } from 'i18next';
import { HitterDataSource } from 'lib_ts/enums/hitters.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { FC, useContext, useMemo, useState } from 'react';

// * if suggestions takes a long time to compute, be careful of using this callout in many places
export const HitterLibraryDuplicateCallout: FC = () => {
  const { hitters } = useContext(HittersContext);

  const [dialog, setDialog] = useState<number>();

  const suggestions = useMemo(() => {
    const nonApiHitters = hitters.filter(
      (h) => h.source !== HitterDataSource.StatsApi
    );

    const apiHitters = hitters.filter(
      (h) => h.source === HitterDataSource.StatsApi
    );

    return HittersHelper.getMergeCandidates(nonApiHitters, apiHitters);
  }, [hitters]);

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary identifier="HitterLibraryDuplicateCallout">
      <Box>
        <CommonCallout
          icon={<ShuffleIcon />}
          color={RADIX.COLOR.ACCENT}
          text={t('hitters.found-x-stats-api-duplicates-msg', {
            x: suggestions.length,
          }).toString()}
          actions={[
            {
              label: 'common.view-details',
              onClick: () => setDialog(Date.now()),
            },
          ]}
        />
      </Box>

      {dialog && (
        <HitterLibraryDuplicateDialog key={dialog} suggestions={suggestions} />
      )}
    </ErrorBoundary>
  );
};
